<template>
<div class="rank" ref="rank">
  <div class="rank-img" >
    <span class="tip">注：学分相同排名不分先后</span>
    <img  class="share" @click="getShareContent" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/share-grey.svg"/>
     <img src="https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/rank.png?x-oss-process=image/resize,m_lfit,w_750"/>
     <div v-if="list.length > 1" class="one absolute">
       <div class="circle">
          <img class="avater" v-lazy="list[1].user.avatar" alt="">
       </div>
       <div class="name">{{list[1].user.fullname}}</div>
       <img class="stat" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/stat-color.svg" alt="">
       <div class="score">{{list[1].score}}</div>
     </div>
     <div v-if="list.length > 0" class="absolute" style="left: 36.27%;top: 21px;">
       <img class="crownfill" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/crownfill.svg"/>
       <div class="circle">
           <img class="avater" v-lazy="list[0].user.avatar" alt="">
       </div>
       <div class="name">{{list[0].user.fullname}}</div>
       <img class="stat" style="width: 28px;height: 28px;" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/stat-color.svg" alt="">
       <div class="score">{{list[0].score}}</div>
     </div>
     <div v-if="list.length > 2"  class="absolute" style="left: 62.4%;top: 108px;">
       <div class="circle">
          <img class="avater" v-lazy="list[2].user.avatar"  alt="">
       </div>
       <div class="name">{{list[2].user.fullname}}</div>
       <img class="stat" style="width: 19px;height: 19px;"  src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/stat-color.svg" alt="">
       <div class="score">{{list[2].score}}</div>
     </div>
  </div>
  <div class="rank-box">
    <div class="rank-box-item" v-for="(item, index) of getList" :key="item.id">
      <div class="number">{{index + 4}}</div>
      <img class="avater" v-lazy="item.user.avatar"/>
      <div class="rank-box-item-box">
        <div class="name">{{item.user.fullname}}</div>
        <div>{{item.user.departmentCh}}</div>
      </div>
      <div class="stat">
        <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/stat.svg" alt="">
      </div>
      <span class="score">{{item.score}}</span>
    </div>
  </div>
</div>
</template>
<script>
import { get } from './../../utils/request'
import { CAMPHOST } from '../../utils/config'
import DDMixis from '../../minixs/ddMixis'
import dd from 'DD'
export default {
  mixins: [DDMixis],
  data () {
    return {
      list: [],
      loading: false,
      page: 1,
      size: 10,
      count: 0,
      platform: dd.env.platform
    }
  },
  mounted () {
    this.getAllRank()
    this.addUpRefresh()
  },
  methods: {
    addUpRefresh () {
      const el = this.$refs.rank
      if (!el) {
        return
      }
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, list, page } = this
          if (count > list.length) {
            this.page = page + 1
            el.scrollTop = el.scrollTop - 60
            // this.loading = false
            this.getAllRank()
          }
        }
      })
    },
    getAllRank () {
      this.loading = true
      const { cid } = this.$route.query
      const promise = get({
        url: `/campsite/cmsRank/${cid}?page=${this.page}&size=${this.size}`,
        baseURL: CAMPHOST
      })
      promise.then(res => {
        const { data: { code, detail: { count, list } } } = res
        if (Object.is(code, 200)) {
          this.list = [...this.list, ...list]
          this.count = count
          this.loading = false
        }
      })
    }
  },
  computed: {
    getList () {
      return this.list.slice(3)
    }
  }
}
</script>
<style lang="scss" scoped>
.rank {
  height: 100vh;
  overflow-y: scroll;
  .tip {
    position: fixed;
    top: 16px;
    left: 12px;
    font-size:11px;
    font-family:AlibabaPuHuiTi-Regular,AlibabaPuHuiTi;
    font-weight:400;
    color:rgba(255,255,255,1);
    height:22px;
    line-height: 22px;
    background:rgba(0,0,0,0.3);
    border-radius:4px;
    z-index: 99;
    padding: 0 6px;
  }
  .rank-img {
    width: 100%;
    position: relative;
    .share {
      position: fixed;
      top: 16px;
      right: 16px;
      width: 44px;
      height: 44px;
      z-index: 99;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .absolute {
      position: absolute;
      top: 85px;
      left: 11.47%;
      width:104px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .crownfill {
        position: absolute;
        top: 0;
        right: 6px;
        width: 25.22px;
        height: 25.22px;
      }
      .circle {
        width: 100%;
        height:104px;
        background:rgba(255,255,255,0.24);
        border:0px solid rgba(151,151,151,1);
        border-radius: 50%;
        .avater {
          margin-left: 8px;
          margin-top: 8px;
          width:88px;
          height:88px;
          border-radius: 50%;
        }
      }
      .name {
        font-size:12px;
        font-family:AlibabaPuHuiTi-Medium,AlibabaPuHuiTi;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:17px;
        margin-top: 4px;
        text-align: center;
      }
      .stat {
        margin-top: 13px;
        width: 24px;
        height: 24px;
        display: block;
        // margin-left: 40px;
      }
      .score {
        text-align: center;
        font-size:12px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(161,32,167,1);
        line-height:17px;
        text-shadow:0px 2px 4px rgba(255,32,114,0.2);
        margin-top: 4px;
      }
    }
  }
  .rank-box {
    width: 100%;
    height: calc(100vh - 391px);
    z-index: 99;
    padding: 0 16px;
    box-sizing: border-box;
    background: #fff;
  }
}
// .four {
//   position: absolute;
//   left: 0;
//   top: 325px;
//   padding: 0 16px;
//   background-image: linear-gradient(to bottom, rgba(255,255,255,0.8), rgba(255,255,255,1));
// }
.rank-box-item {
      width: 100%;
      height: 66px;
      box-sizing: border-box;
      border-bottom: 2px solid #F2F2F7;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .number {
        font-size:12px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(136,136,136,1);
        line-height:22px;
        width: 28px;
        display: inline-block;
      }
      .avater {
        width:36px;
        height:36px;
        border-radius: 50%;
        margin-right: 24px;
      }
      .rank-box-item-box {
        font-size:10px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(136,136,136,1);
        line-height:14px;
        width: 192px;
        box-sizing: border-box;
        .name {
          font-size:12px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(51,51,51,1);
          line-height:17px;
        }
      }
      .stat {
        width:19px;
        height:19px;
        background:rgba(245,245,245,1);
        margin-right: 8px;
        text-align: center;
        border-radius: 50%;
      }
      .score {
        font-size:12px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:17px;
      }
    }
</style>
